var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "26px",
    height: "26px",
    viewBox: "104.541 147.558 26 26",
    enableBackground: "new 104.541 147.558 26 26",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1aba66",
    d: "M127.263,153.644c-2.22-0.004-4.439,0-6.659,0 c-2.201,0-4.403-0.002-6.604,0c-2.116,0.002-3.374,1.25-3.375,3.356c-0.002,4.403-0.003,8.807,0,13.21 c0.001,2.078,1.265,3.347,3.33,3.348c4.421,0.001,8.843,0.001,13.264,0c2.04-0.002,3.319-1.272,3.32-3.303 c0.003-4.439,0.003-8.879,0-13.318C130.538,154.933,129.259,153.648,127.263,153.644z M128.493,170.342 c0,0.796-0.365,1.17-1.149,1.171c-4.511,0.004-9.021,0.004-13.53,0c-0.781-0.001-1.142-0.377-1.143-1.178 c-0.005-2.255-0.002-4.509-0.002-6.765c0-2.219-0.002-4.438,0.001-6.656c0.001-0.868,0.349-1.225,1.205-1.225 c4.474-0.003,8.947-0.003,13.421,0c0.834,0,1.197,0.356,1.198,1.178C128.497,161.358,128.497,165.849,128.493,170.342z  M107.958,165.42c-1.07,0.043-1.378-0.297-1.378-1.375c-0.001-4.368-0.002-8.735,0-13.103c0-1.044,0.302-1.342,1.356-1.343h12.67 c1.633,0,1.667,0.026,1.803,1.663c0.019,0.228,0.08,0.321,0.315,0.314c0.469-0.013,0.938-0.007,1.407-0.003 c0.185,0.002,0.285-0.039,0.321-0.259c0.329-1.997-1.112-3.744-3.14-3.749c-4.529-0.012-9.06-0.009-13.59-0.002 c-1.908,0.003-3.174,1.285-3.179,3.205c-0.006,2.256-0.002,4.512-0.001,6.768c0,2.256-0.007,4.512,0.002,6.768 c0.006,1.738,1.141,2.98,2.855,3.152c1.192,0.119,1.192,0.119,1.192-1.059c0-0.108-0.016-0.219,0.002-0.324 C108.684,165.556,108.488,165.398,107.958,165.42z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy01);
export default __webpack_public_path__ + "static/media/copy-01.4464ae0cf4cfa4b9faef07bdc378b0b7.svg";
export { ForwardRef as ReactComponent };